// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import receptionVisitorEntity from './entities/reception-visitor.json';
import receptionVisitorMenu from '../pages/reception-visitor/menu.json';
import receptionVisitorFullForm from '../pages/reception-visitor/forms/full.json';
import receptionVisitorContextForm from '../pages/reception-visitor/forms/context.json';
import receptionVisitorMiniForm from '../pages/reception-visitor/forms/mini.json';
import receptionVisitorLookupForm from '../pages/reception-visitor/forms/lookup.json';
import receptionVisitorTableView from '../pages/reception-visitor/views/table.json';
import receptionVisitorCardsView from '../pages/reception-visitor/views/cards.json';
import receptionVisitorDashboardView from '../pages/reception-visitor/views/dashboard.json';

/** Тип запису «Відвідувач» зі сторінками пакета: меню, форми та подання з pages/reception-visitor/. */
export const receptionVisitorDefinition: IRecordTypeDefinition = {
  ...receptionVisitorEntity,
  views: assembleViewSet({
      table: receptionVisitorTableView,
      cards: receptionVisitorCardsView,
      dashboard: receptionVisitorDashboardView,
  }),
  form: receptionVisitorFullForm,
  forms: { full: receptionVisitorFullForm, context: receptionVisitorContextForm, mini: receptionVisitorMiniForm, lookup: receptionVisitorLookupForm },
  menu: receptionVisitorMenu,
} as IRecordTypeDefinition;
